export default __webpack_public_path__ + "static/media/monthly-raffle.52a079fd.svg";